var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#238ce6;opacity:0.997;}.b{fill:none;stroke:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(769 1928)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(-769 -1928)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-760.71 -1930.874)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.796)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.38,21.728a.8.8,0,0,0-.648-.547l-8.5-1.235-3.8-7.7a.8.8,0,0,0-1.441,0l-3.8,7.7-8.5,1.235a.8.8,0,0,0-.445,1.37l6.15,6L4.942,37.013a.8.8,0,0,0,1.165.847l7.6-4,7.6,4a.8.8,0,0,0,1.166-.847l-1.452-8.466,6.151-6A.8.8,0,0,0,27.38,21.728Z",
    transform: "translate(0 -11.796)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBlue);
export default __webpack_public_path__ + "static/media/star-blue.881b6552e162adfa4d406ad5ce0ff18a.svg";
export { ForwardRef as ReactComponent };